import React, { useEffect, useCallback } from 'react';
import { Container, Grid, Typography, Stack, IconButton, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
// table component
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { useDispatch } from 'react-redux';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import useAgreementSelector from '../../store/Slice/Agreement/AgreementSelector';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getAgreementView } from '../../store/Slice/Agreement/AgreementSlice';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },

  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

function ViewAgreement(parent) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId, record } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const { AgreementViewData } = useAgreementSelector();

  console.log('AgreementViewData in view agreement', AgreementViewData);

  const getAgreementViewAPi = useCallback(() => {
    if (!LoginData && !rowId) return '';
    const credential = {
      aggrementId: rowId,
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    dispatch(getAgreementView(credential));
  }, [LoginData, rowId]);

  useEffect(() => {
    getAgreementViewAPi();
  }, [getAgreementViewAPi]);

  return (
    <Page title="Partner Management System || Agreement">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="View Agreement" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          {AgreementViewData && AgreementViewData?.agreementIsActive !== false ? (
            <Box className="submitLeadToolbar">
              <Tooltip
                title="Edit"
                placement="top"
                arrow
                onClick={(e) =>
                  navigate(`/agreement/edit`, { state: { rowId: rowId, record: record } })
                }
              >
                <IconButton className="squareIconButton">
                  <FiEdit size={18} />
                </IconButton>
              </Tooltip>
            </Box>
          ) : (
            ''
          )}

          {AgreementViewData?.bankDetails && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Bank Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} marginBottom={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Bank Name
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.bankDetails.bankName || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      PAN Number
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.bankDetails.panNumber || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      GSTIN
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.bankDetails.gstIn || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Commission Structure
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.bankDetails.bankCommissionTypeName || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Turnover Benefit
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.bankDetails.turnoverBenefit
                        ? AgreementViewData.bankDetails.turnoverBenefit
                            .toString()
                            .charAt(0)
                            .toUpperCase() +
                          AgreementViewData.bankDetails.turnoverBenefit.toString().slice(1)
                        : 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          {AgreementViewData?.branchDetails?.length > 0 && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Branch Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <TableContainer sx={{ minWidth: 800, overflow: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Branch Name</StyledTableCell>
                        <StyledTableCell>Branch Address</StyledTableCell>
                        <StyledTableCell>Contact Person</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {AgreementViewData.branchDetails.map((item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell>{item.branchName || 'N/A'}</StyledTableCell>
                          <StyledTableCell>{item.branchAddress || 'N/A'}</StyledTableCell>
                          <StyledTableCell>
                            {item.contactPerson?.contactPersonName || 'N/A'}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )}

          {AgreementViewData?.commissionDetails?.length > 0 && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Commission Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <TableContainer sx={{ minWidth: 800, overflow: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Loan Type</StyledTableCell>
                        <StyledTableCell align="left">Branch</StyledTableCell>
                        <StyledTableCell align="left">Commission %</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {AgreementViewData.commissionDetails.map((item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {item.loanTypeName || 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">{item.branchName || 'N/A'}</StyledTableCell>
                          <StyledTableCell align="left">
                            {item.aggrementCommissionPercentage || 'N/A'}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )}
          {AgreementViewData?.billingDetails && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Billing Details
              </Typography>

              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} marginBottom={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Invoice Mode
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.invoiceMode || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Billing Cycle Day
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.billingCycleDay || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Payment Terms
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.paymentTermsDays || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      GST %
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.gstPercent || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      TDS %
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.tdsPercent || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Chargeback Enabled
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.chargebackEnabled ? 'Yes' : 'No'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Chargeback Period
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.chargebackPeriodDays || 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="body1" className="reviewLabel">
                      Chargeback Amount
                    </Typography>
                    <Typography variant="subtitle2" className="reviewValue">
                      {AgreementViewData.billingDetails.chargebackAmount || 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          {AgreementViewData?.turnoverBenefits?.length > 0 && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Turnover Benefit
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin">
                <TableContainer sx={{ minWidth: 800, overflow: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Loan Type</StyledTableCell>
                        <StyledTableCell align="left">Branch</StyledTableCell>
                        <StyledTableCell align="left">Duration</StyledTableCell>
                        <StyledTableCell align="left">Commission %</StyledTableCell>
                        <StyledTableCell align="left">Unit</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {AgreementViewData.turnoverBenefits.map((item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="left">
                            {item.loanTypeName || 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">{item.branchName || 'N/A'}</StyledTableCell>
                          <StyledTableCell align="left">{item.duration || 'N/A'}</StyledTableCell>
                          <StyledTableCell align="left">
                            {item.aggrementCommissionPercentage || 'N/A'}
                          </StyledTableCell>
                          <StyledTableCell align="left">{item.unit || 'N/A'}</StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )}
        </Box>
      </Container>
    </Page>
  );
}

export default ViewAgreement;
